import { FC, SVGProps } from "react";

const FamilyIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="508"
      height="224"
      viewBox="0 0 508 224"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M477 223H31C31 99.84 130.84 0 254 0c123.159 0 223 99.84 223 223Z"
        fill="#F4F7FA"
      />
      <path stroke="#B8B3B3" strokeLinecap="round" d="M.5 223.5h507" />
      <path
        d="m306.452 141.037 2.903 2.597-.684 3.101-3.865-.664-1.141-2.798 2.787-2.236Z"
        fill="#DEC2A7"
      />
      <path
        d="m252.986 99.548.455 3.323-1.445 2.166-2.345-.336-.303-3.824 3.183-1.55.455.221Z"
        fill="#EACDB0"
      />
      <path
        d="m229.086 100.213 15.26 17.944 3.183-13.957 5.912 1.108-3.411 21.046-5.734 3.881-15.185-9.863-.025-20.159Z"
        fill="#A1BDCC"
      />
      <path
        d="m241.673 141.222.792 32.923-5.852 42.528-4.897.057-3.57-39.138-7.178-39.096 20.705 2.726Z"
        fill="#8C9498"
      />
      <path
        d="m231.738 216.162.032 2.579 5.327 2.519 2.616-2.61-2.679-2.549-5.296.061Zm-16.666 1.243 4.211 3.487-1.053 2.051-7.79-1.64v-3.898h4.632Z"
        fill="#3A3029"
      />
      <path
        d="m224.691 154.173-3.5 31.912-4.618 31.807-6.587-.304.24-32.998-3.965-30.605 9.312-4.226 9.118 4.414Z"
        fill="#8C9498"
      />
      <path
        d="m211.268 97.813 12.795-2.34s8.707 5.458 15.31 21.976c6.724 16.82 5.773 42.582 5.773 42.582s-35.206.548-40.972.681l3.357-35.633 3.737-27.266Z"
        fill="#A1BDCC"
      />
      <path
        d="m219.968 97.956-4.576-.16a21.632 21.632 0 0 1 .017-3.553c-1.292-.355-2.794-.914-3.098-2.188-.096-.401-.051-.82-.005-1.23l.565-5.077c.065-.585.135-1.188.426-1.704.511-.906 1.587-1.355 2.618-1.595 2.632-.614 5.569-.232 7.742 1.34.579.418 1.111.93 1.396 1.575.439.993.233 2.132.019 3.194l-.592 2.94c-.227 1.127-.576 2.414-1.646 2.898-.568.256-1.259.234-1.765.593-.892.634-.68 1.973-1.101 2.967Z"
        fill="#EACDB0"
      />
      <path
        d="M233.719 80.323c-.043-1.15-.283-2.302-.585-3.335-.519-1.774-2.749-2.452-4.643-2.465-4.091-.03-8.136-1.592-12.025.037-2.223.93-5.265 1.305-7.251 2.548-.83.52-1.468 1.29-1.951 2.128-1.672 2.902-1.432 6.746.587 9.43.453.603.984 1.146 1.538 1.662 1.147 1.067 2.521 2.389 4.025 2.718-.049-1.289-1.515-5.272-.569-6.389 1.5-1.772 5.177-1.413 7.201-1.124 2.207.316 4.245 1.698 6.425 1.886 1.569.136 3.504-.729 4.774-1.593 1.991-1.353 2.553-3.425 2.474-5.503Z"
        fill="#3A3029"
      />
      <path
        d="m220.531 97.823 12.482 27.762 4.832 34.464-17.878.366s2.055-25.531 1.316-28.864c-.738-3.333-2.203-10.255-3.791-18.042-.365-1.793-3.035-15.543-3.054-15.46l6.093-.226Z"
        fill="#fff"
      />
      <path
        d="m276.989 101.238-2.005-.503-3.831 2.136-10.915 25.698 3.411 3.988 9.323-11.742 4.017-19.577Z"
        fill="#8AAD9F"
      />
      <path
        d="m293.738 216.092.212 2.043-3.803 2.547-2.22-1.792 1.795-2.294 3.804-2.548.212 2.044Z"
        fill="#514943"
      />
      <path
        d="m293.643 153.632.644 6.205-5.703 21.316 5.296 34.253-3.899 1.312-10.279-33.443-1.632-9.728.06-20.595 15.513.68Z"
        fill="#CAB5A1"
      />
      <path
        d="m263.658 160.547 8.2 57.396h3.728l.67-36.79 6.784-25.823-19.382 5.217Z"
        fill="#CAB5A1"
      />
      <path
        d="M275.565 217.49v2.062l-4.031 2.062-2.015-2.062 2.015-2.062h4.031Z"
        fill="#514943"
      />
      <path
        d="M294.495 136.019c-2.12-11.978-5.403-23.606-6.59-35.806-3.137 0-7.467-1.419-10.732-.574h-.001s-.055.011-.156.045c-1.187.338-2.226.985-3.004 2.133l-.025.039c-1.162 1.241-2.496 3.155-3.745 6.11-3.183 7.532-15.917 51.839-16.144 63.359l.118.027c2.68.813 5.601 1.421 8.647 1.873l.007.002h.003c8.905 1.321 18.869 1.308 26.974 1.175.278-.005 1.252.016 2.539.037 3.655.06 9.831.119 9.713-.409a872.385 872.385 0 0 1-7.604-38.011Z"
        fill="#8AAD9F"
      />
      <path
        d="m287.41 100.766 3.222 1.932 7.807 20.776 8.639 17.058-3.864 3.101-11.369-15.507-6.708-20.935 2.273-6.425Z"
        fill="#8AAD9F"
      />
      <path
        d="M271.774 81.228s-2.415 1.926-1.278 9.015.454 11.741.454 11.741 2.502 1.108 4.321 0 2.501-1.329 1.819-4.209c-.682-2.88-2.047-16.615-2.047-16.615l-3.269.068Z"
        fill="#9E6652"
      />
      <path
        d="M277.767 83.624c-2.762.738-4.936 3.232-5.239 6.01-1.51-1.372-2.28-3.478-2.002-5.473.278-1.995 1.597-3.825 3.427-4.754 1.712.887 3.04 2.456 3.608 4.265l.206-.048Z"
        fill="#9E6652"
      />
      <path
        d="M272.15 87.235c1.427-7.353 10.841-6.082 13.541-.128 1.536 3.386 1.177 10.004-3.145 11.111-.066.651-.152 1.872-.662 2.307-.553.471-2.292.022-2.974-.132-.189-.043-.387-.096-.524-.23-.171-.167-.2-.617-.204-1.115a6.415 6.415 0 0 1-1.534-.295c-2.19-.702-3.776-2.68-4.432-4.836-.656-2.156-.495-4.472-.066-6.682Z"
        fill="#EACDB0"
      />
      <path
        d="M274.134 79.388s-.91 3.988 4.32 5.095c5.23 1.108 8.626 5.096 7.724 9.305-.902 4.209-4.768 7.31-2.721 8.418 2.046 1.108 9.55 0 9.55 0s4.548-14.843-1.592-21.267c-6.139-6.425-15.007-6.646-17.281-1.551Z"
        fill="#9E6652"
      />
      <path
        d="M281.237 111.277c-17.953 3.805-27.078-4.314-28.308-5.513 0 0-.025-.119-.073-.071-.047-.048-.073.071-.073.071-1.227 1.202-10.334 9.339-28.296 5.57 0 0-2.724 31.479 7.757 44.31 11.195 13.704 20.636 17.841 20.684 17.806.047.035 9.56-4.042 20.645-17.847 10.371-12.916 7.664-44.326 7.664-44.326Z"
        fill="#54BAEB"
      />
      <path
        d="M278.612 114.517c-16.292 3.388-24.572-3.841-25.688-4.908 0 0-.023-.107-.066-.064-.043-.043-.066.064-.066.064-1.114 1.07-9.378 8.315-25.678 4.959 0 0-2.472 28.026 7.039 39.448 10.159 12.2 18.718 16.633 18.761 16.601.042.032 8.683-4.348 18.742-16.638 9.412-11.499 6.956-39.462 6.956-39.462Z"
        fill="#76C9F0"
      />
      <path
        d="M226.926 117.765a1.096 1.096 0 0 0-.056-.01c.083-2.855.24-4.642.24-4.642 3.025.622 5.77.88 8.247.88 10.871-.001 16.524-4.968 17.431-5.839 0 0 .016-.074.046-.074.006 0 .013.003.02.01.007-.007.013-.01.02-.01.03 0 .046.074.046.074.907.867 6.545 5.804 17.372 5.804 2.494 0 5.265-.262 8.316-.897 0 0 .157 1.788.239 4.644a.738.738 0 0 1-.046.008 77.23 77.23 0 0 0-.188-3.196c-3.051.634-5.821.896-8.316.896-10.826.001-16.465-4.936-17.372-5.804 0 0-.016-.074-.046-.074-.006 0-.013.003-.02.01-.007-.007-.014-.01-.02-.01-.03 0-.046.074-.046.074-.907.871-6.56 5.839-17.431 5.839-2.477.001-5.222-.257-8.247-.88 0 0-.105 1.197-.189 3.197Z"
        fill="#00ACFE"
      />
      <path
        d="M234.533 118.486c-2.308 0-4.844-.214-7.606-.72.083-2.001.189-3.197.189-3.197 3.024.622 5.77.88 8.247.88 10.871-.001 16.523-4.968 17.431-5.839 0 0 .015-.074.046-.074.006 0 .012.003.019.01.008-.007.014-.01.021-.01.03 0 .046.074.046.074.907.867 6.545 5.804 17.372 5.804 2.494 0 5.265-.262 8.316-.896 0 0 .105 1.196.188 3.196-2.792.518-5.348.736-7.678.736-11.338 0-17.245-5.17-18.195-6.078 0 0-.017-.078-.049-.078-.006 0-.013.003-.021.011-.007-.008-.014-.011-.02-.011-.032 0-.049.078-.049.078-.95.912-6.868 6.115-18.257 6.114Z"
        fill="#54BAEB"
      />
      <path
        d="M252.914 164.648h-.001c-.087 0-6.537-2.852-14.18-12.208-7.186-8.796-6.706-30.105-6.706-30.105 2.2.462 4.25.654 6.139.654 8.685 0 13.958-4.069 14.649-4.746 0 0 .012-.057.035-.057.004 0 .009.003.015.008.005-.005.01-.008.015-.008.023 0 .035.057.035.057.691.674 6.008 4.731 14.687 4.731 1.905 0 3.972-.196 6.187-.665 0 0 .389 21.248-6.721 30.103-7.567 9.424-14.066 12.236-14.154 12.236Z"
        fill="#9EDCFA"
      />
      <path
        d="M256.411 16.42v-2.17l-1.026-2.044c-.255-.283-.793-.273-1.028.021l-.859 2.024v2.17c-.809 0-2.126.619-2.126 1.38 0 .763.656 1.38 1.465 1.38h.661v73.57c0 4.151-2.253 7.604-5.488 7.53-2.507-.058-4.694-2.134-5.062-5.524-.082-.75-.74-1.328-1.541-1.328h-.058c-.926 0-1.652.763-1.537 1.629.64 4.82 4.566 8.269 8.294 8.269 2.913 0 5.302-1.315 6.693-3.686 1.722-2.935 1.612-6.162 1.612-9.383V19.181h.453c.809 0 1.465-.617 1.465-1.38 0-.761-1.109-1.38-1.918-1.38Z"
        fill="#59595B"
      />
      <path d="m253.497 54.714-.03-.031v-4.924h.03v4.955Z" fill="#BDBDBD" />
      <path d="m256.41 57.665-2.913-2.95v-4.956h2.913v7.906Z" fill="#424243" />
      <path
        d="m233.315 64.117.525-3.15c1.818-10.908 6.121-21.28 12.592-30.357l8.178-11.47c-19.91.822-36.981 12.322-45.335 28.776a50.43 50.43 0 0 0-5.043 16.283c4.308-1.255 9.298-1.975 14.636-1.975 5.222 0 10.149.688 14.447 1.893Zm42.77-6.332 1.402 6.76h.524c4.555-1.468 9.953-2.321 15.764-2.321 5.792 0 11.222.847 15.831 2.306a50.538 50.538 0 0 0-7.196-20.366c-9.292-15.025-26.198-25.075-45.514-25.075-.57 0-1.136.01-1.701.028l6.533 9.307c8.009 9.597 11.686 19.32 14.357 29.36Z"
        fill="#FFB781"
      />
      <path
        d="m233.84 60.968-.525 3.149.141.04c5.513-2.388 13.068-3.758 21.412-3.758 8.787 0 16.716 1.519 22.306 4.146h.313l-1.401-6.76c-2.672-10.042-6.349-19.764-14.358-29.361l-6.532-9.307c-.196.006-.391.015-.585.023l-8.178 11.47c-6.471 9.076-10.774 19.45-12.593 30.358Z"
        fill="#FF9A4E"
      />
      <path d="m233.315 64.117-.018.109.159-.069-.141-.04Z" fill="#fff" />
      <path
        d="m247.985 104.2-1.446-2.498.082-3.927 1.364.443.455 1.994 2.501 2.215-.737 2.274-2.219-.501Z"
        fill="#EACDB0"
      />
      <path
        d="m248.029 100.98.328-2.573 2.692-1.95 1.843 1.392-.43 2.141-4.433.99Z"
        fill="#EACDB0"
      />
      <path
        d="m211.35 97.776-5.194 4.125-12.996 22.902 6.821 8.418 4.32-1.329 10.233-22.153-3.184-11.963Z"
        fill="#A1BDCC"
      />
      <path
        d="m212.715 128.347 1.592 3.53v13.108l-2.447.199-3.465-11.321 4.32-5.516Z"
        fill="#EACDB0"
      />
      <path
        d="m217.945 126.353 2.501 2.216 3.183 12.849-2.046 1.108-5.23-10.191-3.638-2.88.682-3.102h4.548Z"
        fill="#EACDB0"
      />
      <path
        d="M197.905 107.01s-1.82.564-2.617 2.117c-.797 1.552-2.922 8.28-1.859 12.938 1.062 4.658 1.593 10.61 11.952 12.68 5.047.518 4.25-3.622 7.969-4.658 3.718-1.035 7.26-.431 5.489-6.037-1.771-5.607-5.755-6.125-9.208-12.077-3.453-5.952-7.25-7.855-11.726-4.963Z"
        fill="#C2969C"
      />
      <path
        d="m196.624 107.662-7.785 4.513-6.139 2.216.682 2.658 6.367-.443 6.367-2.658.508-6.286Zm7.677-2.354 6.595.886 4.746-2.839 1.166 1.51-4.093 4.431-4.776 1.329-3.638-5.317Z"
        fill="#C2969C"
      />
      <path
        d="M200.223 94.14s4.372 1.663 4.839 5.452c0 0 2.082-2.486.405-4.996-1.676-2.51-2.631-3.437-5.161-2.306-2.53 1.13-.083 1.85-.083 1.85Z"
        fill="#754C3D"
      />
      <path
        d="M204.569 97.53c-1.68-5.44-8.683-3.749-10.234.956-.882 2.676-.069 7.644 3.285 8.144.103.486.268 1.4.689 1.689.455.313 1.732-.161 2.234-.33.139-.047.284-.103.377-.215.115-.14.101-.481.062-.857a4.854 4.854 0 0 0 1.135-.343c1.595-.699 2.63-2.316 2.949-3.995.318-1.678.008-3.414-.497-5.05Z"
        fill="#EACDB0"
      />
      <path
        d="M201.439 95.412c-1.533 2.43-4.637 3.212-6.088 5.564 0 0-.949 1.539.037 4.529 0 0-3.255.819-5.395-2.07-2.139-2.89-.203-9.865-.203-9.865s3.284-3.563 8.638-3.458c1.817.036 3.653.982 3.697 2.98.019.855-.25 1.627-.686 2.32Z"
        fill="#754C3D"
      />
      <path
        d="M192.939 213.839s.26 2.085 2.88 2.119c2.621.036 3.689 1.753 1.287 1.721-2.402-.031-5.262.413-6.214-1.332-.951-1.743 1.339-3.747 2.047-2.508Z"
        fill="#BCAC98"
      />
      <path
        d="M184.884 204.522s-.935.196-1.396 1.892c-.461 1.696-11.34-1.216-15.089 1.288-3.748 2.504-4.235 4.623-4.705 8.45-.995 8.085 13.877 7.206 18.927 5.359 5.049-1.849 13.578-2.585 11.298-11.34-.433-.219-9.035-5.649-9.035-5.649Z"
        fill="#D3C2A4"
      />
      <path
        d="m194.645 209.355-.75.575s-3.722 1.171-7.945-3.475c-1.662-2.464-1.13-2.877-1.13-2.877l.946.205s1.747 5.367 8.879 5.572Z"
        fill="#37454D"
      />
      <path
        d="M191.102 196.664s.372-.553 1.428-.575c1.056-.023 2.659 1.662 3.048 1.799.388.137 1.326.362.383.708-.944.345-4.4-.889-4.859-1.932Z"
        fill="#4F3C22"
      />
      <path
        d="M187.461 198.909s1.676-2.239 4.149-2.256c1.461-.01 2.772.588 3.869 1.498.558.464.998 1.023 1.523 1.515.347.326.781.475 1.12.831.802.842 1.184 2.36.873 3.468-.31 1.109.981 4.362-2.828 5.158-3.81.796-8.856-1.445-9.931-3.371-1.075-1.926-2.039-3.879 1.225-6.843Z"
        fill="#DACAAF"
      />
      <path
        d="M188.08 199.183s-1.132-.668-2.078-.212c-.947.456-1.696.291-1.673 1.319.023 1.029-.155 3.6 1.106 4.39 1.26.79.964-1.322 1.606-2.051.643-.728 1.728-3.132 1.039-3.446Z"
        fill="#4F3C22"
      />
      <path
        d="M192.972 214.435s.206 2.978 1.731 3.212c1.526.232 5.217 1.771 4.55 2.613-.667.843-1.747-.023-2.839-.038-1.092-.013-4.274.43-6.931-.594-2.498-.306-3.633.779-3.633.779l7.122-5.972Z"
        fill="#D3C2A4"
      />
      <path
        d="M165.456 212.173c-.375-.108-2.373-.644-2.453-2.931-.08-2.287 1.463-4.146 3.814-4.104 2.352.042 2.309 2.116 1.821 2.422-.488.305-3.362.642-2.944 3.159.326 1.074-.238 1.454-.238 1.454Z"
        fill="#BCAC98"
      />
      <path
        d="M196.57 107.745s.228 2.88 1.819 2.88c1.592 0 4.966-1.355 5.458-1.994.682-.886-.606-2.771-.606-2.771l1.06-.552s7.504 9.304 3.638 11.741c-3.865 2.437-9.095 3.988-10.687.887-1.591-3.102-1.695-9.512-1.695-9.512l1.013-.679Z"
        fill="#F2D263"
      />
      <path
        d="m214.534 144.741 2.046 1.551-.682.886-3.638-.665-.455-1.55 2.729-.222Zm6.82-2.658 2.047-1.44 1.819-.111.455 1.329-3.866 1.33-.455-1.108Z"
        fill="#3A3029"
      />
      <path
        d="m193.176 124.698 7.77-.93 18.451 3.524-.051 4.167-19.272 1.859-5.974-1.908-.924-6.712Z"
        fill="#AECCDC"
      />
      <path
        d="m219.393 127.625 2.787.792 1.423 3.653-1.793 2.037-.682-2.88-1.777-.197.042-3.405Z"
        fill="#DEC2A7"
      />
      <path
        d="m182.773 114.678-3.257-.066v.665l2.501 1.329-.455.443.455.222 1.264-.613-.508-1.98Zm32.992-11.122.588-1.128 1.592-.222.682 1.108-.455 1.329-1.388.141-1.019-1.228Zm51.153 8.322-1.408-1.96-3.709-.401-2.061 3.012-.412 2.81 3.091.603 3.229-4.15 1.27.086Z"
        fill="#EACDB0"
      />
      <path
        d="m324.134 155.596-8.867-1.772-4.777-7.754-2.273 1.772 3.411 10.412 7.504 4.431 5.002-7.089Z"
        fill="#B26650"
      />
      <path
        d="M316.402 191.927v23.483h3.639l2.273-14.178 2.047-10.855-7.959 1.55Zm7.958-2.436 1.365 10.19 1.82 16.393 3.638-.221v-12.627l1.819-12.849-8.642-.886Z"
        fill="#2E4661"
      />
      <path
        d="M322.656 155.263s-3.866-.664-5.456 5.096c-1.592 5.759-5.912 22.596-6.141 31.458-.227 8.861 5.685 3.101 12.735 4.209 7.05 1.108 12.848 1.218 12.848-2.769 0-3.988 2.501-37.883-13.986-37.994Z"
        fill="#B26650"
      />
      <path
        d="M320.436 143.816c3.221-5.532 10.433-1.993 10.928 3.518.28 3.134-1.871 8.36-5.661 8.095-.235.506-.65 1.464-1.181 1.678-.579.231-1.85-.595-2.357-.901-.139-.085-.284-.181-.356-.325-.089-.181.013-.55.151-.951a5.346 5.346 0 0 1-1.151-.649c-1.564-1.149-2.282-3.164-2.201-5.074.08-1.909.86-3.729 1.828-5.391Z"
        fill="#EACDB0"
      />
      <path
        d="M324.932 142.378s5.151 1.255 5.151 3.347c0 3.143.215 5.253 0 7.123l3.65-2.104 2.147-5.856s-.43-4.81-3.005-5.647c-2.577-.836-7.943-1.673-7.943-1.673l-4.078 1.255-3.007-.209 1.039 8.784s1.324-6.274 6.046-5.02Z"
        fill="#754C3D"
      />
      <path
        d="m326.635 156.04 6.368 2.215 5.685 13.735 4.547 9.969-2.501 1.551-7.277-9.969-6.822-17.501Z"
        fill="#B26650"
      />
      <path
        d="m340.734 183.51 1.59 2.215.911-.886h2.728l-2.728-2.88-2.501 1.551Z"
        fill="#EACDB0"
      />
      <path
        d="m316.402 215.411-2.047 1.994.911 1.329 4.093-1.329v-1.994h-2.957Zm11.749.628.758 2.917 2.501.885 1.365-.664-2.119-3.291-2.505.153Z"
        fill="#8C9498"
      />
      <path
        d="m310.49 146.071-2.273-1.551-2.729.665.455 1.55 2.538.902 2.009-1.566Z"
        fill="#EACDB0"
      />
      <path
        d="m307.989 147.463.908-1.781-1.819-.886-2.567.552.522 1.165 2.956.95Z"
        fill="#DEC2A7"
      />
      <path
        d="m236.929 139.362-.043-4.708.618-.006.044 4.709-.619.005Zm4.565-4.752.618-.006.043 4.709-.618.005-2.521-3.713.035 3.736-.619.006-.043-4.708.618-.006 2.521 3.714-.034-3.737Zm1.881 1.238a.644.644 0 0 0 .147.426.848.848 0 0 0 .369.248c.15.053.317.099.501.138.184.039.367.084.552.134.183.051.35.116.5.196.151.08.274.202.371.364.097.162.146.363.148.603a1.29 1.29 0 0 1-.412.962c-.279.274-.657.414-1.134.418-.478.004-.868-.102-1.169-.319a1.049 1.049 0 0 1-.456-.889l.659-.006c.02.213.106.384.259.514.153.13.379.193.678.19.299-.002.536-.081.711-.237.175-.156.262-.336.26-.542-.002-.207-.05-.365-.147-.475a.858.858 0 0 0-.369-.244 3.716 3.716 0 0 0-.5-.135 6.92 6.92 0 0 1-.552-.134 2.406 2.406 0 0 1-.501-.203.969.969 0 0 1-.371-.37 1.223 1.223 0 0 1-.148-.614c-.004-.398.135-.72.415-.965.281-.245.65-.369 1.105-.374.455-.004.818.098 1.09.306.271.208.429.498.473.869l-.686.006a.694.694 0 0 0-.266-.473c-.157-.13-.369-.194-.634-.191-.265.002-.48.071-.647.206-.166.136-.248.332-.246.591Zm2.868 1.768-.029-3.057.626-.006.028 3.057c.004.39.109.68.317.87.207.191.493.284.855.281.363-.003.647-.102.853-.297.207-.194.309-.486.305-.876l-.028-3.057.618-.005.028 3.057c.005.552-.16.975-.495 1.268-.334.293-.76.442-1.279.447-.519.005-.947-.136-1.285-.423-.338-.287-.509-.707-.514-1.259Zm5.004-2.609.016 1.78.911-.009c.339-.003.591-.083.755-.241.164-.158.245-.377.242-.658-.005-.593-.344-.887-1.014-.881l-.91.009Zm.021 2.269.017 1.943-.618.005-.043-4.708 1.529-.014c.53-.005.935.121 1.216.376.281.256.423.571.426.944.003.374-.096.686-.297.937-.201.251-.505.41-.913.477l1.316 1.959-.774.007-1.255-1.932-.604.006Zm4.316.379 1.74-.016-.892-2.425-.848 2.441Zm2.297 1.5-.376-1.029-2.093.019-.357 1.036-.632.006 1.669-4.724.679-.006 1.749 4.692-.639.006Zm3.701-4.749.618-.006.043 4.708-.618.006-2.521-3.714.035 3.737-.619.005-.043-4.708.618-.005 2.521 3.713-.034-3.736Zm1.77 4.049c-.467-.448-.702-1.02-.709-1.715-.006-.696.219-1.271.677-1.726.458-.454 1.024-.685 1.699-.691.489-.005.926.107 1.311.334.385.228.67.558.855.991l-.747.007c-.286-.527-.757-.788-1.414-.782-.511.005-.932.177-1.262.518-.33.34-.492.789-.487 1.346.005.557.175 1.004.512 1.341.336.336.76.502 1.271.498.313-.003.591-.075.834-.215a1.43 1.43 0 0 0 .565-.6l.747-.007a2.045 2.045 0 0 1-.836 1.007 2.48 2.48 0 0 1-1.305.358c-.675.007-1.245-.215-1.711-.664Zm6.891-4.136.005.489-1.875.017.015 1.604 1.671-.016.004.483-1.671.015.016 1.644 1.874-.017.005.489-2.494.023-.043-4.708 2.493-.023Z"
        fill="#2C2C2C"
      />
    </svg>
  );
};

export default FamilyIcon;
